const errors = {
  1: "Permission to fetch location was denied.",
  2: "Location information is unavailable.",
  3: "Getting location timed out.",
  4: "Location is unavailable in this browser.",
  5: "Enable location to fetch your position.",
};

export default function devicePosition({ app, model, navigator, window }) {
  let current = {};
  let watchId;
  let permission;
  let disposed = false;
  const publish = (data) => {
    if (disposed) return;
    if (data.code) current = { error: errors[data.code], errorCode: data.code, update: true };
    else if (data.coords) {
      const { accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed } = data.coords;
      current = { ...current, accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed,
        timestamp: data.timestamp, error: undefined, errorCode: undefined, update: true };
    } else {
      const { alpha, beta, gamma, webkitCompassHeading } = data;
      const compass = Number.isFinite(webkitCompassHeading) ? webkitCompassHeading
        : Number.isFinite(alpha) ? (360 - alpha) % 360 : current.compass;
      current = { ...current, alpha, beta, gamma, compass };
    }
    app.event("mapsDevicePos", current);
  };
  const stopWatch = () => {
    if (watchId !== undefined) navigator.geolocation?.clearWatch(watchId);
    watchId = undefined;
    window.removeEventListener("deviceorientation", publish, true);
  };
  const locate = () => {
    if (disposed) return;
    if (!navigator.geolocation) { publish({ code: 4 }); return; }
    // Start synchronously on a user request so the browser can show its prompt.
    try {
      const options = { enableHighAccuracy: true, timeout: 20000, maximumAge: 30000 };
      navigator.geolocation.getCurrentPosition(publish, publish, options);
      if (watchId === undefined) watchId = navigator.geolocation.watchPosition(publish, publish, options);
      if (model.deviceorientation) window.addEventListener("deviceorientation", publish, true);
    } catch { publish({ code: 2 }); }
  };
  const update = (data) => data.error || data.timestamp ? undefined : { ...current, update: false };
  const start = () => { locate(); };
  const permissionChanged = () => {
    if (permission.state === "granted") locate();
    else { stopWatch(); publish({ code: permission.state === "prompt" ? 5 : 1 }); }
  };
  const initialize = async () => {
    if (!navigator.geolocation) { publish({ code: 4 }); return; }
    // Do not prompt until requested. Missing Permissions API still allows the button.
    try {
      permission = await navigator.permissions?.query({ name: "geolocation" });
      if (disposed) return;
      permission?.addEventListener("change", permissionChanged);
      if (permission?.state === "granted") { locate(); return; }
      publish({ code: permission?.state === "denied" ? 1 : 5 });
    } catch { if (!disposed) publish({ code: 5 }); }
    if (!disposed && model.redirect) app.router?.click(model.redirect);
  };
  app.on("mapsDevicePos", 1000, update);
  app.on("askMapsDevicePos", 1000, start);
  initialize();
  return () => {
    if (disposed) return;
    disposed = true;
    stopWatch();
    permission?.removeEventListener("change", permissionChanged);
    app.off("mapsDevicePos", update);
    app.off("askMapsDevicePos", start);
  };
}
